export class AddressResponse {
    Result: number;
    Reason: string;
    Response: string
}